import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Cell, Icon, Input, Spacer, Tooltip } from "src/components";
import { debounce } from "src/util/util";
import styled from "styled-components";


export interface ISearchbarProps {
  placeholder?:    string;
  onChange?(value: string): void;
  toggleAdv?():    void;
  advButton?:      boolean;
}

export const Searchbar = (props: ISearchbarProps) => {
  const { placeholder, onChange, toggleAdv, advButton } = props;
  const { t, i18n }               = useTranslation();
  const [value, setValue]         = React.useState<string>("");
  const mount = React.useRef<boolean>(false);
  const debouncedChange           = React.useCallback(debounce(onChange || (() => {}), 250), [onChange]);
  React.useEffect(()=> {
    if(!mount.current) mount.current = true;
    else debouncedChange(value);
  }, [value]);

  return (
    <Container>  
      <Input icons  = {[
            {
              iconId: "search",
            }
          ]} placeholder={placeholder || t("search_placeholder")} value={value} onChange={val => setValue(val)} />
      <Spacer size="xxsmall"/>
      <div>
      {advButton && <Tooltip content={t("filter")}><Button variant="icon" onClick={toggleAdv}><Icon size="xlarge" color="black" iconId="filter"/></Button></Tooltip>}
      </div>
      </Container>
  )}

const Container = styled.div`
  display: flex;
  align-items: center;
`;